<ion-header>
  <ion-toolbar class="toolbar">
    <ion-title>Recomendaciones</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding recommendations-container">
  <ion-grid>
    <ion-row class="ion-padding">
      <ion-col size="12">
        <p class="ion-text-center recommendation-title">Elige una recomendación</p>
      </ion-col>
    </ion-row>

    <!-- Diseño para Tris, chispazo y melate -->
    <ion-row
      *ngIf="gameType === 'tris' || gameType === 'melate' || gameType === 'chispazo'; else otherGames"
      class="recommendation-row"
    >
      <ion-col size="12">
        <ion-card *ngFor="let rec of trisRecommendations" class="recommendation-card">
          <ion-card-header>
            <ion-card-title>{{ rec.category | titlecase }}</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <div class="number-container" *ngIf="!isLoading; else loadingTemplate">
              <div class="number-bubble" *ngFor="let num of rec.numbers" [ngClass]="getBubbleClass(gameType, num)">
                {{ num < 0 ? 'X' : num }}
              </div>
            </div>
            <ng-template #loadingTemplate>
              <div class="loading-container">
                <ion-spinner name="crescent"></ion-spinner>
              </div>
            </ng-template>
            <ion-button
              expand="block"
              color="primary"
              class="select-button"
              (click)="apply(rec.numbers, rec.category)"
              [disabled]="isLoading"
            >
              Seleccionar
            </ion-button>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <ng-template #otherGames>
      <!-- Diseño para otros juegos -->
      <ion-row class="recommendation-row">
        <ion-col size="12">
          <ion-card class="recommendation-card" *ngFor="let rec of recommendationsList">
            <ion-card-header>
              <ion-card-title>Números recomendados</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <div class="number-container" *ngIf="!isLoading; else loadingTemplate">
                <div class="number-bubble" *ngFor="let num of rec.numbers" [ngClass]="getBubbleClass(gameType)">
                  {{ num }}
                </div>

                <div *ngIf="rec.signName && rec.signNumber">
                  <img [src]="getZodiacIcon(rec.signName)" />
                  <h3>{{ formatZodiacName(rec.signName) }}</h3>
                </div>
              </div>

              <ng-template #loadingTemplate>
                <div class="loading-container">
                  <ion-spinner name="crescent"></ion-spinner>
                </div>
              </ng-template>

              <ion-button
                expand="block"
                color="primary"
                class="select-button"
                (click)="apply(rec.numbers, 'defaultCategory', rec.signName)"
                [disabled]="isLoading"
              >
                Seleccionar
              </ion-button>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ng-template>
    <ion-grid
      *ngIf="gameType === 'protouch' && (protouchRecommendations?.length ?? 0) > 0"
      class="protouch-grid"
      else
      otherGames
    >
      <ion-accordion-group expand="inset">
        <ion-accordion *ngFor="let rec of protouchRecommendations" [value]="rec">
          <ion-item slot="header" color="light">
            <ion-label> <strong>Touch:</strong> {{ rec.recommendedNumbers['touch'] }} </ion-label>
          </ion-item>

          <div slot="content" class="protouch-container">
            <!-- Título visible dentro del contenido también -->
            <ion-row class="header-row">
              <ion-col>
                <div class="title">PROTOUCH INICIAL</div>
                <div class="touch-box selected">{{ rec.recommendedNumbers['touch'] }}</div>
              </ion-col>
            </ion-row>

            <!-- Cabeceras -->
            <ion-row class="column-headers">
              <ion-col>Gana x dif de más de 6 pts (L)</ion-col>
              <ion-col class="center-col">Dif max de 6 pts (D)</ion-col>
              <ion-col class="right-col">Gana x dif de más de 6 pts (V)</ion-col>
            </ion-row>

            <!-- Partidos -->
            <ion-row *ngFor="let i of [].constructor(13); let index = index" class="game-row">
              <!-- LOCAL -->
              <ion-col class="team-cell" [ngClass]="{ selected: rec.recommendedNumbers['L' + (index + 1)] }">
                <ion-icon name="shirt-outline" class="jersey-icon"></ion-icon>
              </ion-col>

              <!-- DIFERENCIA -->
              <ion-col class="diff-cell" [ngClass]="{ selected: rec.recommendedNumbers['D' + (index + 1)] }">
                <ion-icon name="shirt-outline" class="jersey-icon"></ion-icon>
              </ion-col>

              <!-- VISITANTE -->
              <ion-col class="team-cell right-col" [ngClass]="{ selected: rec.recommendedNumbers['V' + (index + 1)] }">
                <ion-icon name="shirt-outline" class="jersey-icon"></ion-icon>
              </ion-col>
            </ion-row>
            <ion-button
              (click)="applyProtouchRecommendation(rec.recommendedNumbers)"
              expand="block"
              color="primary"
              class="select-button"
            >
              Seleccionar
            </ion-button>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </ion-grid>

    <ion-grid *ngIf="gameType === 'progol' && progolMSRecommendations" class="progol-grid">
      <ion-accordion-group expand="inset">
        <ion-accordion *ngFor="let rec of progolMSRecommendations" [value]="rec">
          <ion-item slot="header" color="light">
            <ion-label>
              <strong>Progol 1/2 Semana</strong>
            </ion-label>
          </ion-item>
          <div slot="content" class="progol-container">
            <!-- Cabeceras -->
            <ion-row class="column-headers">
              <ion-col>Local</ion-col>
              <ion-col class="center-col">Empate</ion-col>
              <ion-col class="right-col">Visita</ion-col>
            </ion-row>

            <!-- Partidos -->
            <ion-row *ngFor="let i of [].constructor(9); let index = index" class="game-row">
              <!-- LOCAL -->
              <ion-col class="team-cell" [ngClass]="{ 'selected-local': rec.recommendedNumbers['L' + (index + 1)] }">
                <ion-icon name="shirt-outline" class="jersey-icon"></ion-icon>
              </ion-col>

              <!-- EMPATE -->
              <ion-col class="diff-cell" [ngClass]="{ 'selected-draw': rec.recommendedNumbers['D' + (index + 1)] }">
                <ion-icon name="shirt-outline" class="jersey-icon"></ion-icon>
              </ion-col>

              <!-- VISITA -->
              <ion-col
                class="team-cell right-col"
                [ngClass]="{ 'selected-visitor': rec.recommendedNumbers['V' + (index + 1)] }"
              >
                <ion-icon name="shirt-outline" class="jersey-icon"></ion-icon>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="!rec.isMediaSemana">
              <ion-col size="12" class="ion-text-center">
                <p class="warning-text">⚠️ Esta recomendación es para Progol Revancha</p>
              </ion-col>
            </ion-row>
            <!-- Botón -->
            <ion-button
              (click)="applyProgolMSRecommendation(rec.recommendedNumbers)"
              expand="block"
              color="primary"
              class="select-button"
            >
              Seleccionar
            </ion-button>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </ion-grid>

    <ion-grid *ngIf="progolRevanchaRecommendations.length > 0 && gameType === 'progol'" class="progol-grid">
      <ion-accordion-group expand="inset">
        <ion-accordion
          *ngFor="let revanchaRec of progolRevanchaRecommendations; let idx = index"
          [value]="'revancha-' + idx"
        >
          <ion-item slot="header" color="light">
            <ion-label>
              <strong>Progol Revancha</strong>
            </ion-label>
          </ion-item>

          <div slot="content" class="progol-container">
            <ion-row class="column-headers">
              <ion-col>Local</ion-col>
              <ion-col class="center-col">Empate</ion-col>
              <ion-col class="right-col">Visita</ion-col>
            </ion-row>

            <ion-row *ngFor="let i of quinielaIndices" class="game-row">
              <ion-col class="team-cell" [ngClass]="{ 'selected-local': revanchaRec.recommendedNumbers['L' + i] }">
                <ion-icon name="shirt-outline" class="jersey-icon"></ion-icon>
              </ion-col>
              <ion-col class="diff-cell" [ngClass]="{ 'selected-draw': revanchaRec.recommendedNumbers['D' + i] }">
                <ion-icon name="shirt-outline" class="jersey-icon"></ion-icon>
              </ion-col>
              <ion-col
                class="team-cell right-col"
                [ngClass]="{ 'selected-visitor': revanchaRec.recommendedNumbers['V' + i] }"
              >
                <ion-icon name="shirt-outline" class="jersey-icon"></ion-icon>
              </ion-col>
            </ion-row>
            <div *ngIf="revanchaRec.revRecommended">
              <ion-row class="ion-text-center revancha-header">
                <ion-col size="12">
                  <strong>Revancha</strong>
                </ion-col>
              </ion-row>
              <ion-row class="column-headers">
                <ion-col>Local</ion-col>
                <ion-col class="center-col">Empate</ion-col>
                <ion-col class="right-col">Visita</ion-col>
              </ion-row>
              <ion-row *ngFor="let i of revanchaIndices" class="game-row">
                <ion-col class="team-cell" [ngClass]="{ 'selected-local': revanchaRec.revRecommended['LR' + i] }">
                  <ion-icon name="shirt-outline" class="jersey-icon"></ion-icon>
                </ion-col>
                <ion-col class="diff-cell" [ngClass]="{ 'selected-draw': revanchaRec.revRecommended['DR' + i] }">
                  <ion-icon name="shirt-outline" class="jersey-icon"></ion-icon>
                </ion-col>
                <ion-col
                  class="team-cell right-col"
                  [ngClass]="{ 'selected-visitor': revanchaRec.revRecommended['VR' + i] }"
                >
                  <ion-icon name="shirt-outline" class="jersey-icon"></ion-icon>
                </ion-col>
              </ion-row>
            </div>

            <ion-row>
              <ion-col size="12">
                <ion-button
                  expand="block"
                  color="primary"
                  class="select-button"
                  (click)="applyProgolRevanchaRecommendation(revanchaRec)"
                >
                  Seleccionar
                </ion-button>
              </ion-col>
            </ion-row>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </ion-grid>

    <ng-container *ngIf="isLoading">
      <ion-spinner name="crescent" class="spinner-centered"></ion-spinner>
    </ng-container>
  </ion-grid>
</ion-content>
